/* Greenic Startseite (16.10.2026), Vorlage startseite/vorschau/build_home.py (Stand 2).
   Wird von mehreren greenic-home-Sections mit defer eingebunden und läuft trotzdem nur einmal (window.__ghHome).
   Teile: 1 Pfeile an Wisch-Reihen (Bewertungen), 2 Punkte unter der Über-uns-Reihe (greenic-pdp-about; auf der PDP macht das
   greenic-pdp.js Teil 3, das hier nicht geladen ist), 3 FAQ: weiche Höhe ohne interpolate-size per Web Animations, Öffnen per Link
   oder Sprungmarke, 4 Blatt "Frag uns direkt" (dialog mit Shopify-Kontaktformular), 5 Hero mit einer Folie je Marke (Umschalter,
   Pille läuft beim Wischen mit, Stand 16.10.2026 22:30). Im Theme-Editor nach shopify:section:load neu. */
(function () {
  if (window.__ghHome) return;
  window.__ghHome = 1;
  var d = document;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var EASE = 'cubic-bezier(.22,.61,.36,1)';

  /* 1 Pfeile an Wisch-Reihen */
  function rails(root) {
    root.querySelectorAll('[data-gh-nav]').forEach(function (nav) {
      if (nav.__gh) return;
      var rail = d.getElementById(nav.getAttribute('data-gh-nav'));
      var b = nav.querySelectorAll('button');
      if (!rail || b.length < 2) return;
      nav.__gh = 1;
      function step(dir) {
        var c = rail.firstElementChild;
        var w = c ? c.getBoundingClientRect().width + 12 : rail.clientWidth * 0.8;
        rail.scrollBy({ left: dir * w, behavior: reduce ? 'auto' : 'smooth' });
      }
      function upd() {
        b[0].disabled = rail.scrollLeft < 4;
        b[1].disabled = rail.scrollLeft + rail.clientWidth >= rail.scrollWidth - 4;
      }
      b[0].addEventListener('click', function () { step(-1); });
      b[1].addEventListener('click', function () { step(1); });
      rail.addEventListener('scroll', upd, { passive: true });
      window.addEventListener('resize', upd);
      upd();
    });
  }

  /* 2 Punkte unter der Über-uns-Reihe: scrollsnapchange, sonst IntersectionObserver */
  function dots(root) {
    root.querySelectorAll('[data-gx-about] .gxp__track').forEach(function (track) {
      var box = track.parentNode.querySelector('.gxp__dots');
      if (!box || box.children.length || track.__gh) return;
      track.__gh = 1;
      var cards = [].slice.call(track.children);
      if (cards.length < 2) return;
      cards.forEach(function (c) {
        var bt = d.createElement('button');
        bt.type = 'button';
        bt.tabIndex = -1;
        bt.addEventListener('click', function () {
          var x = track.scrollLeft + c.getBoundingClientRect().left - track.getBoundingClientRect().left - 20;
          track.scrollTo({ left: x, behavior: reduce ? 'auto' : 'smooth' });
        });
        box.appendChild(bt);
      });
      var bts = box.children;
      function mark(i) { for (var k = 0; k < bts.length; k++) bts[k].setAttribute('aria-current', String(k === i)); }
      mark(0);
      if ('onscrollsnapchange' in HTMLElement.prototype) {
        track.addEventListener('scrollsnapchange', function (e) { var i = cards.indexOf(e.snapTargetInline); if (i > -1) mark(i); });
      } else if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (es) {
          es.forEach(function (en) { if (en.isIntersecting) mark(cards.indexOf(en.target)); });
        }, { root: track, threshold: 0.6 });
        cards.forEach(function (c) { io.observe(c); });
      }
    });
  }

  /* 3 FAQ */
  var smoothCss = !!(window.CSS && CSS.supports && CSS.supports('interpolate-size', 'allow-keywords'));
  function openFaq(det, scroll) {
    if (!det) return;
    det.open = true;
    if (scroll) det.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' });
    var s = det.querySelector('summary');
    if (s) s.focus({ preventScroll: true });
  }
  function faq(root) {
    if (!reduce && !smoothCss) {
      root.querySelectorAll('.ghf details').forEach(function (det) {
        if (det.__gh) return;
        det.__gh = 1;
        var sum = det.querySelector('summary');
        var a = det.querySelector('.ghf__a');
        if (!sum || !a || !a.animate) return;
        sum.addEventListener('click', function (e) {
          e.preventDefault();
          if (det.dataset.anim) return;
          det.dataset.anim = '1';
          if (!det.open) {
            var n = det.getAttribute('name');
            if (n) d.querySelectorAll('details[name="' + n + '"]').forEach(function (o) { if (o !== det && o.open) o.open = false; });
            det.open = true;
            var h = a.offsetHeight;
            a.animate([{ height: '0px', opacity: 0 }, { height: h + 'px', opacity: 1 }], { duration: 380, easing: EASE }).onfinish = function () { delete det.dataset.anim; };
          } else {
            var h2 = a.offsetHeight;
            a.animate([{ height: h2 + 'px', opacity: 1 }, { height: '0px', opacity: 0 }], { duration: 300, easing: EASE }).onfinish = function () { det.open = false; delete det.dataset.anim; };
          }
        });
      });
    }
    root.querySelectorAll('a[data-gh-open]').forEach(function (a) {
      if (a.__gh) return;
      a.__gh = 1;
      a.addEventListener('click', function (e) {
        var href = a.getAttribute('href') || '';
        if (href.charAt(0) !== '#') return;
        var det = d.getElementById(href.slice(1));
        if (det && det.tagName === 'DETAILS') { e.preventDefault(); openFaq(det, true); }
      });
    });
  }
  function hash() {
    var h = location.hash.slice(1);
    if (!h) return;
    var det = d.getElementById(decodeURIComponent(h));
    if (det && det.tagName === 'DETAILS' && det.closest('.ghf')) openFaq(det, true);
  }

  /* 4 Blatt "Frag uns direkt" */
  function ask(root) {
    root.querySelectorAll('[data-ghask-open]').forEach(function (btn) {
      if (btn.__gh) return;
      btn.__gh = 1;
      btn.addEventListener('click', function () {
        var dlg = d.getElementById(btn.getAttribute('data-ghask-open'));
        if (dlg && dlg.showModal && !dlg.open) dlg.showModal();
      });
    });
    root.querySelectorAll('dialog.ghask').forEach(function (dlg) {
      if (dlg.__gh) return;
      dlg.__gh = 1;
      dlg.addEventListener('click', function (e) {
        if (e.target.closest('[data-ghask-close]')) dlg.close();
      });
      /* Schließen per Klick neben das Blatt: closedby="any" im Markup; ohne Unterstützung (Safari) per Klick auf den Hintergrund */
      if (!('closedBy' in HTMLDialogElement.prototype)) {
        dlg.addEventListener('click', function (e) {
          if (e.target !== dlg) return;
          var r = dlg.getBoundingClientRect();
          var inside = r.top <= e.clientY && e.clientY <= r.top + r.height && r.left <= e.clientX && e.clientX <= r.left + r.width;
          if (!inside) dlg.close();
        });
      }
      var form = dlg.querySelector('form');
      var done = dlg.querySelector('.ghask__done');
      if (dlg.querySelector('[data-ghask-posted]') && form && done && dlg.showModal) {
        form.hidden = true;
        var head = dlg.querySelector('.ghask__head');
        if (head) head.hidden = true;
        done.hidden = false;
        dlg.showModal();
      } else if (dlg.querySelector('.ghask__errors') && dlg.showModal) {
        dlg.showModal();
      }
    });
  }

  /* 5 Hero mit einer Folie je Marke. Die Pille im Umschalter hängt an der Scroll-Position der Folien und läuft beim Wischen mit.
     Antrieb A (Chrome, Safari 26 u. a.): CSS-Scroll-Timeline --ghh-tl, nur wenn sie nachweislich an dieser Reihe hängt.
     Antrieb B (alle übrigen): scroll plus requestAnimationFrame, setzt --ghh-k (Position 0 bis n-1) und --ghh-s (Dehnung) am Umschalter.
     In der Bewegung Klasse ghh--moving (Pille hebt sich), Ende per scrollend oder 140 ms nach dem letzten scroll (Pille rastet ein).
     aria-current folgt der eingerasteten Folie (scrollsnapchange, sonst Ende der Bewegung) und beim Tippen sofort. */
  var SDA = !!(window.CSS && CSS.supports && CSS.supports('(animation-timeline: --a) and (timeline-scope: --a) and (animation-range: entry)'));
  function hero(root) {
    root.querySelectorAll('[data-gh-hero]').forEach(function (sec) {
      if (sec.__gh) return;
      var track = sec.querySelector('.ghh__track');
      var bar = sec.querySelector('.ghh__tabs');
      var thumb = sec.querySelector('.ghh__thumb');
      var slides = track ? [].slice.call(track.children) : [];
      var tabs = [].slice.call(sec.querySelectorAll('[data-gh-slide]'));
      if (slides.length < 2 || !tabs.length || !bar) return;
      sec.__gh = 1;
      var n = slides.length, cur = -1, raf = 0, idle = 0, moving = false;
      var css = !!(SDA && thumb && thumb.getAnimations && thumb.getAnimations().some(function (a) {
        return a.timeline && a.timeline.source === track;
      }));
      if (!css) sec.classList.add('ghh--js');
      function step() { return (slides[1].offsetLeft - slides[0].offsetLeft) || track.clientWidth || 1; }
      function pos() { var k = track.scrollLeft / step(); return k < 0 ? 0 : (k > n - 1 ? n - 1 : k); }
      function mark(i) {
        if (i === cur || !tabs[i]) return;
        cur = i;
        tabs.forEach(function (t, j) { t.setAttribute('aria-current', String(j === i)); });
      }
      function paint() {
        raf = 0;
        if (css) return;
        var k = pos();
        var s = reduce ? 0 : Math.sin(Math.PI * k);
        bar.style.setProperty('--ghh-k', k.toFixed(4));
        bar.style.setProperty('--ghh-s', (s * s).toFixed(4));
      }
      function settle() {
        clearTimeout(idle);
        idle = 0;
        if (moving) { moving = false; sec.classList.remove('ghh--moving'); }
        mark(Math.round(pos()));
      }
      track.addEventListener('scroll', function () {
        if (!css && !raf) raf = requestAnimationFrame(paint);
        if (!moving && !reduce) { moving = true; sec.classList.add('ghh--moving'); }
        clearTimeout(idle);
        idle = setTimeout(settle, 140);
      }, { passive: true });
      track.addEventListener('scrollend', settle);
      if ('onscrollsnapchange' in HTMLElement.prototype) {
        track.addEventListener('scrollsnapchange', function (e) { var i = slides.indexOf(e.snapTargetInline); if (i > -1) mark(i); });
      }
      tabs.forEach(function (t) {
        t.addEventListener('click', function () {
          var i = parseInt(t.getAttribute('data-gh-slide'), 10) || 0;
          if (!slides[i]) return;
          track.scrollTo({ left: slides[i].offsetLeft - slides[0].offsetLeft, behavior: reduce ? 'auto' : 'smooth' });
          mark(i);
        });
      });
      function again() { if (!raf) raf = requestAnimationFrame(paint); mark(Math.round(pos())); }
      window.addEventListener('resize', again);
      window.addEventListener('pageshow', again);
      paint();
      mark(Math.round(pos()));
    });
  }

  function init(root) { rails(root); dots(root); faq(root); ask(root); hero(root); }
  init(d);
  hash();
  window.addEventListener('hashchange', hash);
  d.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
